mutation Inertia_UpdateDocument($documentId: ID!, $name: String!) {
  updateDocument(input: { documentId: $documentId, name: $name }) {
    document {
      id
      name
    }
    errors
  }
}